// extracted by mini-css-extract-plugin
export default {"container":"DatePicker_container__ZAu2K","placeholder":"DatePicker_placeholder__WcPI0","arrow":"DatePicker_arrow__cftp1","open":"DatePicker_open__hRntA"};